module.exports = __webpack_public_path__ + "img/shopping_application_202604-3.58405f01.jpg";